const Colors= {
    background:"#0E0E20",
    input:{
        Form:"#F2F2F2",
        Fonts:"#584848"
    },
    Button:{
        background:"#000",
        color:"#fff"
    }
}

export default Colors